import { startNewEdit } from "./briefLocalStorageManager";

function uniqBy(a, key) {
    var seen = {};
    return a.filter(function(item) {
        var k = key(item);
        return seen.hasOwnProperty(k) ? false : (seen[k] = true);
    })
}

export function get_info_by_inn(inn, setLoadingINN, action, formik, need_to_create=true) {
    if (!inn) {
        setLoadingINN(false);
        return
    }

    fetch(`${process.env.REACT_APP_API_HOST}/api/get_info_by_id?` + new URLSearchParams({
            id: parseInt(inn)
        }).toString(), {
            method: 'GET'
      }).then((res) => {
        if (res.status !== 200) {
            setLoadingINN(false);
            return
        }

        res.json().then((data) => {
            Object.entries(data).forEach(([key, value]) => {
                formik.setFieldValue(key, value);
            });
            setLoadingINN(false);

            if (need_to_create) {
                action(true);
            } else {
                action(data);
            }
        });
      });
}

export function getBrief(id, setBriefData, formik) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/${id}`, {
        method: 'GET'
    }).then((res) => {
        res.json().then((data) => {
            if (!data.id) return
            let finalData = sectionsToTree(data);
            setBriefData(finalData);

            Object.entries(formik.initialValues).forEach(([key, _]) => {
                formik.setFieldValue(key, data[key]);
            })
        });
    });
}

export function getBriefByKey(key, setBriefData) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/view/${key}`, {
        method: 'GET'
    }).then((res) => {
        res.json().then((data) => {
            if (!data.id) return
            let finalData = sectionsToTree(data);
            setBriefData(finalData);
        });
    });
}

export function deleteBriefSection(id, type) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/${type}s/${id}`, {
        method: 'DELETE',
    }).then((res) => {
    });
}

export async function updateBrief(id, data) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((res) => {
    });
}

export async function updateBriefSection(id, type, data) {
    console.log(type, data)
    fetch(`${process.env.REACT_APP_API_HOST}/api/${type}s/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((res) => {
    });
}

export function updateBriefSectionBatch(updates) {
    try {
        fetch(`${process.env.REACT_APP_API_HOST}/api/brief/batch/`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates),
        });
      } catch (error) {
        console.error('Failed to update sections:', error);
      }
}

export function updateBriefField(id, field, value) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({[field]: value})
    }).then((res) => {
        res.json().then((data) => { });
    });
}

export function updateBriefFields(id, fields) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/${id}`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(fields)
    }).then((res) => {
        res.json().then((data) => { });
    });
}

function sectionsToTree(data) {
    let newData = [...data.sections.map(i => {return {...i, type: 'section'}}),
        ...data.parameters.map(i => {return {...i, type: 'parameter'}})].map(item => {
            let r = {
                id: item.id,
                text: item.name,
                droppable: item.type == 'section',
                parent: item.section_id ? item.section_id : 0,
                data: {
                    type: item.type,
                    have_file: item.have_file,
                    have_input: item.have_input,
                    have_ocr: item.have_ocr,
                    files: item.files,
                    input_text: item.input_text,
                    index: item.index,
                    updated_at: new Date(item.updated_at)
                }
            }

            if (item.parameters) {
                r.children = item.parameters.map(q => {
                    return {
                        id: q.id,
                        text: q.name,
                        droppable: false,
                        parent: item.id,
                        data: {
                            type: 'parameter',
                            have_file: q.have_file,
                            have_input: q.have_input,
                            have_ocr: q.have_ocr,
                            files: q.files,
                            input_text: q.input_text,
                            index: q.index,
                            updated_at: new Date(q.updated_at)
                        }};
                })
            }

            return r;
        })

    let finalData = [];

    newData.forEach(item => {
    finalData.push(item);
    if (item.children) {
        item.children.forEach(child => {
            finalData.push(child);
        })
    }
    });

    console.log(finalData)

    finalData = uniqBy(finalData, (item) => item.id);

    return finalData.sort(compare)
}

export function compare( a, b ) {
    if ( a.data.index < b.data.index ){
      return -1;
    }
    if ( a.data.index > b.data.index ){
      return 1;
    }

    if ( a.data.updated_at > b.data.updated_at ){
      return -1;
    }
    if ( a.data.updated_at < b.data.updated_at ){
      return 1;
    }
  }

export function createBrief(data, setBriefData) {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({manager_id: 2, ...data})
    }).then((res) => {
        res.json().then((data) => {
            startNewEdit(data.id, data.key);

            let finalData = sectionsToTree(data);
            setBriefData(finalData);
        });
    });
}

export function deleteBrief(brief_id) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/${brief_id}`, {
        method: 'DELETE',
    }).then((res) => {
        
    });
}

export async function createSection(data) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/sections/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({manager_id: 2, ...data})
    }).then(async (res) => {
        const data = await res.json();
        return data;
    });
}

export async function createParameter(data) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/parameters/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({manager_id: 2, ...data})
    }).then(async (res) => {
        const data = await res.json();
        return data;
    })
}

export async function getFileHashById(file_id) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/get_file_hash_by_id/${file_id}`, {
        method: 'GET',
    }).then(async (res) => {
        const data = await res.json();
        return data.hash;
    })
}

export async function getFileStatus(file_id, setStatus) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/file_status/${file_id}`, {
        method: 'GET',
    }).then(async (res) => {
        const data = await res.json();
        setStatus(data.status);
    })
}

export async function downloadCSV(data) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/convert-to-csv/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(async (response) => {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "output.csv";
        document.body.appendChild(a);
        a.click();
        a.remove();
    })
}

export async function downloadExcel(data) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/convert-to-excel/`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(async (response) => {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "output.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
    })
}

export async function downloadZIP(parameter_id) {
    return fetch(`${process.env.REACT_APP_API_HOST}/api/parameters/download_zip/${parameter_id}`, {
        method: 'POST'
    }).then(async (response) => {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `parameter_${parameter_id}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
    })
}